"use strict";
/*
 * Copyright 2021. Amazon.com, Inc. or its affiliates. All Rights Reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndpoint = void 0;
function getEndpoint(stage, region, isFipsEnabled) {
    const fips = isFipsEnabled ? "-fips" : "";
    if (stage.toLowerCase() === `prod`) {
        return `https://workspaces-web${fips}.${region}.amazonaws.com`;
    }
    return `https://${region}-${stage}${fips}.ermine-cp.cloudbrowse.aws.dev`;
}
exports.getEndpoint = getEndpoint;
